import axiosInstance from './axiosInstance';

const normalizeList = (data) => {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.promotions)) return data.promotions;
  if (data && Array.isArray(data.data)) return data.data;
  return [];
};

export const PROMO_SLOTS = [
  { value: 'section_header', label: 'Section header (title & subtitle)' },
  { value: 'row1_left', label: 'Row 1 — Left panel (moss)' },
  { value: 'row1_feature', label: 'Row 1 — Feature panel (large, with image)' },
  { value: 'row1_tiles', label: 'Row 1 — Category tiles (4 tiles)' },
  { value: 'row2_left', label: 'Row 2 — Left panel' },
  { value: 'row2_tiles', label: 'Row 2 — Category tiles (4 tiles)' },
  { value: 'row3_banner', label: 'Row 3 — Full-width banner' },
];

export const mapPromotionFromApi = (p) => {
  if (!p) return null;
  return {
    id: p.id,
    slot: p.slot ?? '',
    sortOrder: Number(p.sort_order ?? p.sortOrder ?? 0),
    tag: p.tag ?? '',
    heading: p.heading ?? '',
    headingLine2: p.heading_line2 ?? p.headingLine2 ?? '',
    discountText: p.discount_text ?? p.discountText ?? '',
    subtitle: p.subtitle ?? '',
    bodyText: p.body_text ?? p.bodyText ?? '',
    ctaPrimaryLabel: p.cta_primary_label ?? p.ctaPrimaryLabel ?? 'Shop Now',
    ctaPrimaryUrl: p.cta_primary_url ?? p.ctaPrimaryUrl ?? '/products',
    ctaSecondaryLabel: p.cta_secondary_label ?? p.ctaSecondaryLabel ?? '',
    ctaSecondaryUrl: p.cta_secondary_url ?? p.ctaSecondaryUrl ?? '',
    categorySlug: p.category_slug ?? p.categorySlug ?? '',
    panelStyle: p.panel_style ?? p.panelStyle ?? 'moss',
    imagePath: p.image_path ?? p.imagePath ?? '',
    isActive: Boolean(p.is_active ?? p.isActive ?? true),
    createdAt: p.created_at ?? p.createdAt,
    updatedAt: p.updated_at ?? p.updatedAt,
  };
};

export const fetchPromotions = async (slot) => {
  const response = await axiosInstance.get('/promotions', {
    params: slot ? { slot } : undefined,
  });
  return normalizeList(response.data).map(mapPromotionFromApi).filter(Boolean);
};

export const createPromotion = async (payload) => {
  const formData = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (key === 'file') return;
    formData.append(key, value);
  });
  if (payload.file) formData.append('promoImage', payload.file);

  const response = await axiosInstance.post('/promotions', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const updatePromotion = async (id, payload) => {
  const formData = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (key === 'file') return;
    formData.append(key, value);
  });
  if (payload.file) formData.append('promoImage', payload.file);

  const response = await axiosInstance.put(`/promotions/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const deletePromotion = async (id) => {
  await axiosInstance.delete(`/promotions/${id}`);
};
